import React from 'react';

const PopupNotification = ({ visible, message, onClose }) => {
  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        backdropFilter: 'blur(4px)',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '20px',
          boxShadow: '0 10px 20px rgba(0,0,0,0.3)',
          padding: '24px',
          width: '90%',
          maxWidth: '400px',
          maxHeight: '80vh',
          overflowY: 'auto',
          boxSizing: 'border-box',
          margin: '0 16px',
          textAlign: 'center',
        }}
      >
        <h2 style={{ color: '#FF0083', fontWeight: 'normal', marginBottom: '12px', fontSize: '1.5rem' }}>
          Error
        </h2>
        <p style={{ color: '#333', marginBottom: '20px', fontWeight: 'normal' }}>{message}</p>
        <button
          onClick={onClose}
          style={{
            padding: '10px 24px',
            backgroundColor: '#FF0083',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            fontWeight: 'normal',
            fontSize: '1rem',
          }}
          onMouseOver={e => (e.currentTarget.style.backgroundColor = '#e60074')}
          onMouseOut={e => (e.currentTarget.style.backgroundColor = '#FF0083')}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default PopupNotification;
